<template>
  <div>
    <div class="flex-around pv-1x">
      <span>版本号：{{ version ? version : "-" }}</span>
      <span>
        门票纸数量：{{
          machineDetail.remainingVotes ? machineDetail.remainingVotes : "-"
        }}
      </span>
      <span>
        服务电话：{{
          machineDetail.serviceTelephone ? machineDetail.serviceTelephone : "-"
        }}
      </span>
    </div>

    <div class="place"></div>
  </div>
</template>
<script>
export default {
  name: "QmpBottom",
  components: {},
  props: {},
  data() {
    return {
      version: ""
    };
  },
  computed: {
    machineDetail() {
      return this.$store.state.setting.machineDetail;
    }
  },
  created() {
    this.getVer();
  },
  methods: {
    getVer() {
      try {
        this.version = window.test.getVersion();
      } catch (error) {
        console.log("获取软件版本失败", error);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.flex-around {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 110px;
  background: #3a3a3a;
  color: #fff;
  z-index: 100;
}

.place {
  height: 42px;
}
</style>
